import { api } from "./api";

/** Откуда взята дневная производительность продукции. */
export type CapacitySource = "manual" | "fact" | "default" | "none";

export interface ResolvedCapacity {
  value: number;
  source: CapacitySource;
  /** Факт за 30 дней — показываем рядом с нормой, даже когда норма задана вручную. */
  fact: number;
  factDays: number;
}

export interface QueueOrderRow {
  id: string;
  clientName: string;
  position: number;
  isUrgent: boolean;
  /** Остаток к выдаче — сколько заказ занимает в очереди. */
  need: number;
  fromStock: number;
  toProduce: number;
  cumulativeToProduce: number;
  /** 0 — готов сейчас, null — производительность неизвестна. */
  days: number | null;
}

export interface ProduceQueueCard {
  produceId: string;
  produceName: string;
  unitOfMeasurement?: string;
  queue: number;
  ordersCount: number;
  residue: number;
  free: number;
  toProduce: number;
  days: number | null;
  capacity: ResolvedCapacity;
}

export interface ProduceQueueDetail extends ProduceQueueCard {
  rows: QueueOrderRow[];
}

export interface QueueOverview {
  produces: ProduceQueueCard[];
  totals: {
    produces: number;
    orders: number;
    withoutCapacity: number;
    withFreeStock: number;
  };
  bottleneck: { produceId: string; produceName: string; days: number | null } | null;
}

export const fetchQueueOverview = async (): Promise<QueueOverview> => {
  const { data } = await api.get("/production-queue");
  return data;
};

export const fetchProduceQueue = async (produceId: string): Promise<ProduceQueueDetail> => {
  const { data } = await api.get(`/production-queue/${produceId}`);
  return data;
};

export const reorderProduceQueue = async (
  produceId: string,
  orderedIds: string[]
): Promise<{ message: string; queue: ProduceQueueDetail }> => {
  const { data } = await api.put(`/production-queue/${produceId}/reorder`, { orderedIds });
  return data;
};

export interface UrgentResult {
  message: string;
  /** Заказы, у которых из-за срочного вырос срок. */
  shifted: Array<{ id: string; clientName: string; wasDays: number | null; nowDays: number | null }>;
  queue: ProduceQueueDetail;
}

export const setOrderUrgent = async (id: string, isUrgent: boolean): Promise<UrgentResult> => {
  const { data } = await api.put(`/production-queue/order/${id}/urgent`, { isUrgent });
  return data;
};

export interface SaleCheck {
  ok: boolean;
  free: number;
  overdraft: number;
  affected: Array<{ id: string; clientName: string; taken: number }>;
  warning: string | null;
}

export const checkSaleAgainstQueue = async (
  produceId: string,
  quantity: number
): Promise<SaleCheck> => {
  const { data } = await api.get(`/production-queue/${produceId}/check-sale`, {
    params: { quantity },
  });
  return data;
};
